import React from "react";
import colors from "../../styles/colors";

export type IconProps = React.ComponentProps<"svg">;

/**
 * These SVGs are all open source icons from Feather: https://feathericons.com/
 */

export const KeyboardArrowDownIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"></path>
    </svg>
  );
};
export const ArrowUpIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="10"></circle>
      <polyline points="16 12 12 8 8 12"></polyline>
      <line x1="12" y1="16" x2="12" y2="8"></line>
    </svg>
  );
};

export const CheckIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="20 6 9 17 4 12"></polyline>
    </svg>
  );
};

export const ChevronDown: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  );
};

export const ChevronUp: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="18 15 12 9 6 15"></polyline>
    </svg>
  );
};

export const ChevronRight: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  );
};

export const ChevronLeft: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  );
};

export const CopyIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
      <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
    </svg>
  );
};

export const EditIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
    </svg>
  );
};

export const EmailIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
      <polyline points="22,6 12,13 2,6"></polyline>
    </svg>
  );
};

export const ExternalLinkIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
      <polyline points="15 3 21 3 21 9"></polyline>
      <line x1="10" y1="14" x2="21" y2="3"></line>
    </svg>
  );
};

export const EyeIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  );
};

export const EyeOffIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
      <line x1="1" y1="1" x2="23" y2="23"></line>
    </svg>
  );
};

export const AgentGridIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.7 5.4C0.649733 5.4 0.61617 5.384 0.6 5.37214V0.627858C0.61617 0.616001 0.649733 0.6 0.7 0.6H6.3C6.35027 0.6 6.38383 0.616001 6.4 0.627858V5.37214C6.38383 5.384 6.35027 5.4 6.3 5.4H0.7Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.7 15.4C9.64973 15.4 9.61617 15.384 9.6 15.3721V10.6279C9.61617 10.616 9.64973 10.6 9.7 10.6H15.3C15.3503 10.6 15.3838 10.616 15.4 10.6279V15.3721C15.3838 15.384 15.3503 15.4 15.3 15.4H9.7Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.6 7.2V0.8C9.6 0.720429 9.62832 0.661878 9.65665 0.629503C9.67044 0.613741 9.68228 0.606223 9.68885 0.603041C9.69463 0.600248 9.69768 0.6 9.7 0.6H15.3C15.3023 0.6 15.3054 0.600248 15.3111 0.603041C15.3177 0.606223 15.3296 0.613741 15.3434 0.629503C15.3717 0.661878 15.4 0.720429 15.4 0.8V7.2C15.4 7.27957 15.3717 7.33812 15.3434 7.3705C15.3296 7.38626 15.3177 7.39378 15.3111 7.39696C15.3054 7.39975 15.3023 7.4 15.3 7.4H9.7C9.69768 7.4 9.69463 7.39975 9.68885 7.39696C9.68228 7.39378 9.67044 7.38626 9.65665 7.3705C9.62832 7.33812 9.6 7.27957 9.6 7.2Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.6 15.2V8.8C0.6 8.72043 0.628318 8.66188 0.656646 8.6295C0.670438 8.61374 0.682276 8.60622 0.688854 8.60304C0.69463 8.60025 0.69768 8.6 0.7 8.6H6.3C6.30232 8.6 6.30537 8.60025 6.31115 8.60304C6.31772 8.60622 6.32956 8.61374 6.34335 8.6295C6.37168 8.66188 6.4 8.72043 6.4 8.8V15.2C6.4 15.2796 6.37168 15.3381 6.34335 15.3705C6.32956 15.3863 6.31772 15.3938 6.31115 15.397C6.30537 15.3998 6.30232 15.4 6.3 15.4H0.7C0.69768 15.4 0.694629 15.3998 0.688854 15.397C0.682276 15.3938 0.670437 15.3863 0.656646 15.3705C0.628318 15.3381 0.6 15.2796 0.6 15.2Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OverviewIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.06667 0.6H14.9333C15.1911 0.6 15.4 0.808933 15.4 1.06667V14.9333C15.4 15.1911 15.1911 15.4 14.9333 15.4H1.06667C0.808933 15.4 0.6 15.1911 0.6 14.9333V1.06667C0.6 0.808934 0.808934 0.6 1.06667 0.6Z"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 3.5H13" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M3 6.5H11" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M3 9.5H9" strokeWidth="1.2" strokeLinecap="round" />
      <path d="M3 12.5H12" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};

export const GridIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      fill="currentColor"
      stroke="currentColor"
      height="24"
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBox="-1 -1 28 28"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M3.69231 0C1.66226 0 0 1.66226 0 3.69231C0 5.72236 1.66226 7.38462 3.69231 7.38462C4.34495 7.38462 4.94712 7.19712 5.48077 6.89423L7.5 9.14423C6.86178 9.9375 6.46154 10.9147 6.46154 12C6.46154 13.006 6.80048 13.9219 7.35577 14.6827L5.74038 16.3269C5.73317 16.3233 5.71875 16.3305 5.71154 16.3269C5.1274 15.9375 4.44231 15.6923 3.69231 15.6923C1.66226 15.6923 0 17.3546 0 19.3846C0 21.4147 1.66226 23.0769 3.69231 23.0769C5.72236 23.0769 7.38462 21.4147 7.38462 19.3846C7.38462 18.7788 7.21514 18.2163 6.95192 17.7115L8.71154 15.9519C9.40745 16.3738 10.2115 16.6154 11.0769 16.6154C11.7332 16.6154 12.357 16.4639 12.9231 16.2115L13.9904 17.7404C13.3377 18.4075 12.9231 19.3089 12.9231 20.3077C12.9231 22.3377 14.5853 24 16.6154 24C18.6454 24 20.3077 22.3377 20.3077 20.3077C20.3077 18.2776 18.6454 16.6154 16.6154 16.6154C16.2548 16.6154 15.905 16.6911 15.5769 16.7885L14.4231 15.1442C15 14.5313 15.4291 13.774 15.6058 12.9231H16.7596C17.1707 14.5096 18.5986 15.6923 20.3077 15.6923C22.3377 15.6923 24 14.03 24 12C24 9.96995 22.3377 8.30769 20.3077 8.30769C18.5986 8.30769 17.1707 9.49038 16.7596 11.0769H15.6058C15.3858 10.0168 14.7764 9.08654 13.9615 8.42308L14.3654 7.32692C14.4988 7.34135 14.6322 7.38462 14.7692 7.38462C16.7993 7.38462 18.4615 5.72236 18.4615 3.69231C18.4615 1.66226 16.7993 0 14.7692 0C12.7392 0 11.0769 1.66226 11.0769 3.69231C11.0769 4.91827 11.7079 5.98918 12.6346 6.66346L12.2885 7.55769C11.899 7.44952 11.4988 7.38462 11.0769 7.38462C10.2909 7.38462 9.56611 7.60817 8.91346 7.96154L6.80769 5.65385C7.17188 5.08414 7.38462 4.41346 7.38462 3.69231C7.38462 1.66226 5.72236 0 3.69231 0ZM3.69231 1.84615C4.72356 1.84615 5.53846 2.66106 5.53846 3.69231C5.53846 4.20793 5.32212 4.65865 4.99038 4.99038C4.65865 5.32212 4.20793 5.53846 3.69231 5.53846C2.66106 5.53846 1.84615 4.72356 1.84615 3.69231C1.84615 2.66106 2.66106 1.84615 3.69231 1.84615ZM14.7692 1.84615C15.8005 1.84615 16.6154 2.66106 16.6154 3.69231C16.6154 4.72356 15.8005 5.53846 14.7692 5.53846C13.738 5.53846 12.9231 4.72356 12.9231 3.69231C12.9231 2.66106 13.738 1.84615 14.7692 1.84615ZM11.0769 9.23077C12.6058 9.23077 13.8462 10.4712 13.8462 12C13.8425 12.0397 13.8425 12.0757 13.8462 12.1154C13.7849 13.5865 12.5661 14.7692 11.0769 14.7692C10.3846 14.7692 9.74639 14.524 9.25962 14.1058C8.67188 13.5974 8.30769 12.8365 8.30769 12C8.30769 10.4712 9.54808 9.23077 11.0769 9.23077ZM20.3077 10.1538C21.3389 10.1538 22.1538 10.9688 22.1538 12C22.1538 13.0313 21.3389 13.8462 20.3077 13.8462C19.2764 13.8462 18.4615 13.0313 18.4615 12C18.4615 10.9688 19.2764 10.1538 20.3077 10.1538ZM3.69231 17.5385C4.72356 17.5385 5.53846 18.3534 5.53846 19.3846C5.53846 20.4159 4.72356 21.2308 3.69231 21.2308C2.66106 21.2308 1.84615 20.4159 1.84615 19.3846C1.84615 18.3534 2.66106 17.5385 3.69231 17.5385ZM16.6154 18.4615C17.6466 18.4615 18.4615 19.2764 18.4615 20.3077C18.4615 21.3389 17.6466 22.1538 16.6154 22.1538C15.5841 22.1538 14.7692 21.3389 14.7692 20.3077C14.7692 19.6947 15.0685 19.1719 15.5192 18.8365C15.6599 18.7897 15.7897 18.7103 15.8942 18.6058C15.905 18.6022 15.9123 18.5805 15.9231 18.5769C16.1358 18.494 16.3702 18.4615 16.6154 18.4615Z" />
    </svg>
  );
};

export const HelpCircleIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      fill="none"
      height="24"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="24"
      {...props}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor"></circle>
      <path
        d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"
        stroke="currentColor"
      ></path>
      <line stroke="currentColor" x1="12" x2="12.01" y1="17" y2="17"></line>
    </svg>
  );
};

export const ListIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="8" y1="6" x2="21" y2="6"></line>
      <line x1="8" y1="12" x2="21" y2="12"></line>
      <line x1="8" y1="18" x2="21" y2="18"></line>
      <line x1="3" y1="6" x2="3.01" y2="6"></line>
      <line x1="3" y1="12" x2="3.01" y2="12"></line>
      <line x1="3" y1="18" x2="3.01" y2="18"></line>
    </svg>
  );
};

export const LogoutIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
      <polyline points="16 17 21 12 16 7"></polyline>
      <line x1="21" y1="12" x2="9" y2="12"></line>
    </svg>
  );
};

export const MessageSquareIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      fill="none"
      height="24"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  );
};

export const MenuIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="3" y1="12" x2="21" y2="12"></line>
      <line x1="3" y1="6" x2="21" y2="6"></line>
      <line x1="3" y1="18" x2="21" y2="18"></line>
    </svg>
  );
};

export const MoreVertical: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="1"></circle>
      <circle cx="12" cy="5" r="1"></circle>
      <circle cx="12" cy="19" r="1"></circle>
    </svg>
  );
};

export const DestinationIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_i_3202_142926)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 1H30C30.5523 1 31 1.44772 31 2V30C31 30.5523 30.5523 31 30 31H24C23.4477 31 23 30.5523 23 30V2C23 1.44772 23.4477 1 24 1ZM18 9H13C12.4477 9 12 9.44771 12 10V30C12 30.5523 12.4477 31 13 31H18C18.5523 31 19 30.5523 19 30V10C19 9.44771 18.5523 9 18 9ZM7 17H2C1.44772 17 1 17.4477 1 18V30C1 30.5523 1.44772 31 2 31H7C7.55228 31 8 30.5523 8 30V18C8 17.4477 7.55228 17 7 17Z"
          fill="url(#paint0_linear_3202_142926)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3202_142926"
          x="1"
          y="1"
          width="30"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.135 0 0 0 0 0.145 0 0 0 0 0.165 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3202_142926"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3202_142926"
          x1="16"
          y1="1"
          x2="16"
          y2="31"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.middleLightGray} />
          <stop offset="1" stopColor={colors.lightGray} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PauseIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="rgb(165,165,165)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-pause"
      {...props}
    >
      <rect x="6" y="4" width="4" height="16"></rect>
      <rect x="14" y="4" width="4" height="16"></rect>
    </svg>
  );
};

export const PencilIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
    </svg>
  );
};

export const PlayIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="rgb(46,163,92)"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="feather feather-play"
      {...props}
    >
      <polygon points="5 3 19 12 5 21 5 3"></polygon>
    </svg>
  );
};

export const PlusCircleIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      className="feather feather-plus-circle"
      fill="none"
      height="24"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12" cy="12" r="10"></circle>
      <line x1="12" x2="12" y1="8" y2="16"></line>
      <line x1="8" x2="16" y1="12" y2="12"></line>
    </svg>
  );
};

export const ProcessorIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke={colors.middleGray}
      {...props}
    >
      <path
        d="M9.90869 3.54548V1"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0913 3.54548V1"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 3.54548V1"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0001 20.0918H26.4546"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0001 9.9082H26.4546"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.0001 15H26.4546"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.54548 20.0918H1"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.54548 9.9082H1"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.54548 15H1"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.90869 29.0006V26.4551"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0913 29.0006V26.4551"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 29.0006V26.4551"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.9092 3.54492H6.09089C4.68506 3.54492 3.54541 4.68457 3.54541 6.0904V23.9088C3.54541 25.3146 4.68506 26.4542 6.09089 26.4542H23.9092C25.3151 26.4542 26.4547 25.3146 26.4547 23.9088V6.0904C26.4547 4.68457 25.3151 3.54492 23.9092 3.54492Z"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.3617 8.63672H8.63428V21.3641H21.3617V8.63672Z"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const UploadCloudIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="16 16 12 12 8 16"></polyline>
      <line x1="12" y1="12" x2="12" y2="21"></line>
      <path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path>
      <polyline points="16 16 12 12 8 16"></polyline>
    </svg>
  );
};

export const UsersIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  );
};

export const RadioIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="12" cy="12" r="2"></circle>
      <path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>
    </svg>
  );
};

export const RefreshIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="23 4 23 10 17 10"></polyline>
      <polyline points="1 20 1 14 7 14"></polyline>
      <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
    </svg>
  );
};

export const SearchIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  );
};

export const SendIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="22" y1="2" x2="11" y2="13"></line>
      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
    </svg>
  );
};

export const SettingsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      fill="none"
      height="24"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      stroke="currentColor"
      viewBox="0 0 24 24"
      width="24"
      {...props}
    >
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>
    </svg>
  );
};

export const SlackIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path>
      <path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path>
      <path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path>
      <path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path>
      <path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path>
      <path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path>
      <path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path>
      <path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>
    </svg>
  );
};

export const SlidersIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3202_116932)">
        <path
          d="M0.6 14.4V1.6C0.6 1.04817 1.04817 0.6 1.6 0.6H14.4C14.9518 0.6 15.4 1.04817 15.4 1.6V14.4C15.4 14.9518 14.9518 15.4 14.4 15.4H1.6C1.04817 15.4 0.6 14.9518 0.6 14.4Z"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 3L10.5 13"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 6H8.5"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 13V3"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 10H3.5"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3202_116932">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ConfigurationIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g filter="url(#filter0_i_3202_116701)">
        <path
          d="M36.125 0.375H5.875C2.83762 0.375 0.375 2.83762 0.375 5.875V36.125C0.375 39.1624 2.83762 41.625 5.875 41.625H36.125C39.1624 41.625 41.625 39.1624 41.625 36.125V5.875C41.625 2.83762 39.1624 0.375 36.125 0.375ZM30.625 7.25C30.625 6.48962 31.241 5.875 32 5.875C32.759 5.875 33.375 6.48962 33.375 7.25V23.75C33.375 24.5104 32.759 25.125 32 25.125C31.241 25.125 30.625 24.5104 30.625 23.75V7.25ZM8.625 7.25C8.625 6.48962 9.241 5.875 10 5.875C10.759 5.875 11.375 6.48962 11.375 7.25V23.75C11.375 24.5104 10.759 25.125 10 25.125C9.241 25.125 8.625 24.5104 8.625 23.75V7.25ZM14.125 30.625H11.375V34.75C11.375 35.5104 10.759 36.125 10 36.125C9.241 36.125 8.625 35.5104 8.625 34.75V30.625H5.875C5.116 30.625 4.5 30.0104 4.5 29.25C4.5 28.4896 5.116 27.875 5.875 27.875H14.125C14.884 27.875 15.5 28.4896 15.5 29.25C15.5 30.0104 14.884 30.625 14.125 30.625ZM22.375 34.75C22.375 35.5104 21.759 36.125 21 36.125C20.241 36.125 19.625 35.5104 19.625 34.75V18.25C19.625 17.4896 20.241 16.875 21 16.875C21.759 16.875 22.375 17.4896 22.375 18.25V34.75ZM25.125 14.125H16.875C16.116 14.125 15.5 13.5104 15.5 12.75C15.5 11.9896 16.116 11.375 16.875 11.375H19.625V7.25C19.625 6.48962 20.241 5.875 21 5.875C21.759 5.875 22.375 6.48962 22.375 7.25V11.375H25.125C25.884 11.375 26.5 11.9896 26.5 12.75C26.5 13.5104 25.884 14.125 25.125 14.125ZM36.125 30.625H33.375V34.75C33.375 35.5104 32.759 36.125 32 36.125C31.241 36.125 30.625 35.5104 30.625 34.75V30.625H27.875C27.116 30.625 26.5 30.0104 26.5 29.25C26.5 28.4896 27.116 27.875 27.875 27.875H36.125C36.884 27.875 37.5 28.4896 37.5 29.25C37.5 30.0104 36.884 30.625 36.125 30.625Z"
          fill="url(#paint0_linear_3202_116701)"
        />
      </g>
      <defs>
        <filter
          id="filter0_i_3202_116701"
          x="0.375"
          y="0.375"
          width="41.25"
          height="43.25"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.135 0 0 0 0 0.145 0 0 0 0 0.165 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3202_116701"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3202_116701"
          x1="21"
          y1="0.375"
          x2="21"
          y2="41.625"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.middleLightGray} />
          <stop offset="1" stopColor={colors.lightGray} />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const DestinationsIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_3202_116942)">
        <path
          d="M1.06667 0.6H14.9333C15.1911 0.6 15.4 0.808933 15.4 1.06667V14.9333C15.4 15.1911 15.1911 15.4 14.9333 15.4H1.06667C0.808933 15.4 0.6 15.1911 0.6 14.9333V1.06667C0.6 0.808934 0.808934 0.6 1.06667 0.6Z"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 9.5L5.5 6.5L9.5 10.5L13.5 6.5"
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3202_116942">
          <rect width="16" height="16" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EmptyTableIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      stroke={colors.middleLightGray}
      width={"150px"}
      viewBox="0 0 76 90"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <g strokeWidth="2" transform="translate(0.000000, 2.000000)">
          <circle cx="70" cy="82" r="4.5"></circle>
          <circle cx="38" cy="82" r="4.5"></circle>
          <path
            d="M37.9840567,44.5878906 L37.9840567,77.309082"
            strokeLinejoin="round"
          ></path>
          <circle cx="6" cy="82" r="4.5"></circle>
          <path
            d="M27.7763672,44.5878906 L27.7763672,66.2089844 L8.95214844,66.2089844 C7.29529419,66.2089844 5.95214844,67.5521301 5.95214844,69.2089844 L5.95214844,76.59375"
            strokeLinejoin="round"
          ></path>
          <path
            d="M70.0478516,44.59 L70.0478516,66.2110938 L51.2236328,66.2110938 C49.5667786,66.2110938 48.2236328,67.5542395 48.2236328,69.2110938 L48.2236328,76.5958594"
            strokeLinejoin="round"
            transform="translate(59.135742, 60.592930) scale(-1, 1) translate(-59.135742, -60.592930) "
          ></path>
          <path
            d="M15.42,19.76 C16.5245695,19.76 17.42,18.8645695 17.42,17.76 C17.4272594,8.66532033 24.3038254,1.0457632 33.3501042,0.108698456 C42.3963831,-0.828366283 50.6887403,5.21990797 52.56,14.12 C52.7809814,15.1931999 53.824361,15.8887864 54.9,15.68 C57.216284,15.2419429 59.6068846,15.8666352 61.4127531,17.3818595 C63.2186215,18.8970839 64.2490623,21.1428362 64.22,23.5 C64.0772223,24.5150514 64.7249791,25.4737315 65.72,25.72 C76.26,28.42 74.26,44 63.42,44 L15.42,44 C8.7263089,43.9999999 3.30000018,38.5736911 3.30000018,31.88 C3.30000018,25.1863089 8.7263089,19.7600001 15.42,19.76 Z"
            fillRule="nonzero"
          ></path>
          <g
            strokeLinecap="round"
            strokeLinejoin="round"
            transform="translate(27.000000, 14.000000)"
          >
            <circle cx="9" cy="9" r="9"></circle>
            <path d="M22,22 L15.8188477,15.8188477"></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const TrashIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <polyline points="3 6 5 6 21 6"></polyline>
      <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
    </svg>
  );
};

export const FileIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path>
      <polyline points="13 2 13 9 20 9"></polyline>
    </svg>
  );
};

export const UserXIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="8.5" cy="7" r="4"></circle>
      <line x1="18" y1="8" x2="23" y2="13"></line>
      <line x1="23" y1="8" x2="18" y2="13"></line>
    </svg>
  );
};

export const XIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  );
};

export const BookmarkIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
    </svg>
  );
};

/**
 * Miscellaneous (non-feather) icons.
 */

export const BusinessIcon: React.FC<IconProps> = (props) => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" {...props}>
      <g clipPath="url(#clip0_150_2266)">
        <path
          d="M23.3333 15.15L38.0167 18.0667C39.2 18.3167 40 19.3167 40 20.5V37.5C40 38.8833 38.8833 40 37.5 40H22.5C22.9667 40 23.3333 39.6333 23.3333 39.1667V38.3333H37.5C37.95 38.3333 38.3333 37.9667 38.3333 37.5V20.5C38.3333 20.1167 38.0667 19.7667 37.6833 19.6833L23.3333 16.85V15.15Z"
          fill="black"
        />
        <path
          d="M32.5 23.3333C32.9667 23.3333 33.3334 23.7 33.3334 24.1666C33.3334 24.6333 32.9667 25 32.5 25H29.1667C28.7 25 28.3334 24.6333 28.3334 24.1666C28.3334 23.7 28.7 23.3333 29.1667 23.3333H32.5Z"
          fill="black"
        />
        <path
          d="M32.5 28.3333C32.9667 28.3333 33.3334 28.7 33.3334 29.1666C33.3334 29.6333 32.9667 30 32.5 30H29.1667C28.7 30 28.3334 29.6333 28.3334 29.1666C28.3334 28.7 28.7 28.3333 29.1667 28.3333H32.5Z"
          fill="black"
        />
        <path
          d="M32.5 33.3333C32.9667 33.3333 33.3334 33.7 33.3334 34.1666C33.3334 34.6333 32.9667 35 32.5 35H29.1667C28.7 35 28.3334 34.6333 28.3334 34.1666C28.3334 33.7 28.7 33.3333 29.1667 33.3333H32.5Z"
          fill="black"
        />
        <path
          d="M23.3333 39.1667C23.3333 39.6333 22.9666 40 22.5 40C22.0333 40 21.6666 39.6333 21.6666 39.1667V38.3333V15.8333C21.6666 15.5833 21.7833 15.35 21.9666 15.1833C22.1666 15.0333 22.4166 14.9667 22.6666 15.0167L23.3333 15.15V16.85V38.3333V39.1667Z"
          fill="black"
        />
        <path
          d="M21.6667 38.3333V39.1666C21.6667 39.6333 22.0334 40 22.5 40H15.8334C16.3 40 16.6667 39.6333 16.6667 39.1666V38.3333H21.6667Z"
          fill="black"
        />
        <path
          d="M17.5 8.33331C17.9667 8.33331 18.3334 8.69998 18.3334 9.16665C18.3334 9.63331 17.9667 9.99998 17.5 9.99998H14.1667C13.7 9.99998 13.3334 9.63331 13.3334 9.16665C13.3334 8.69998 13.7 8.33331 14.1667 8.33331H17.5Z"
          fill="black"
        />
        <path
          d="M18.3334 14.1666C18.3334 14.6333 17.9667 15 17.5 15H14.1667C13.7 15 13.3334 14.6333 13.3334 14.1666C13.3334 13.7 13.7 13.3333 14.1667 13.3333H17.5C17.9667 13.3333 18.3334 13.7 18.3334 14.1666Z"
          fill="black"
        />
        <path
          d="M17.5 18.3333C17.9667 18.3333 18.3334 18.7 18.3334 19.1666C18.3334 19.6333 17.9667 20 17.5 20H14.1667C13.7 20 13.3334 19.6333 13.3334 19.1666C13.3334 18.7 13.7 18.3333 14.1667 18.3333H17.5Z"
          fill="black"
        />
        <path
          d="M17.5 23.3333C17.9667 23.3333 18.3334 23.7 18.3334 24.1666C18.3334 24.6333 17.9667 25 17.5 25H14.1667C13.7 25 13.3334 24.6333 13.3334 24.1666C13.3334 23.7 13.7 23.3333 14.1667 23.3333H17.5Z"
          fill="black"
        />
        <path
          d="M10 24.1666C10 24.6333 9.63333 25 9.16667 25H5.83333C5.36667 25 5 24.6333 5 24.1666C5 23.7 5.36667 23.3333 5.83333 23.3333H9.16667C9.63333 23.3333 10 23.7 10 24.1666Z"
          fill="black"
        />
        <path
          d="M9.16667 8.33331C9.63333 8.33331 10 8.69998 10 9.16665C10 9.63331 9.63333 9.99998 9.16667 9.99998H5.83333C5.36667 9.99998 5 9.63331 5 9.16665C5 8.69998 5.36667 8.33331 5.83333 8.33331H9.16667Z"
          fill="black"
        />
        <path
          d="M9.16667 13.3333C9.63333 13.3333 10 13.7 10 14.1666C10 14.6333 9.63333 15 9.16667 15H5.83333C5.36667 15 5 14.6333 5 14.1666C5 13.7 5.36667 13.3333 5.83333 13.3333H9.16667Z"
          fill="black"
        />
        <path
          d="M9.16667 18.3333C9.63333 18.3333 10 18.7 10 19.1666C10 19.6333 9.63333 20 9.16667 20H5.83333C5.36667 20 5 19.6333 5 19.1666C5 18.7 5.36667 18.3333 5.83333 18.3333H9.16667Z"
          fill="black"
        />
        <path
          d="M15 30.8333C15 30.3666 14.6166 30 14.1666 30H9.16663C8.69996 30 8.33329 30.3666 8.33329 30.8333V38.3333H6.66663V30.8333C6.66663 29.45 7.78329 28.3333 9.16663 28.3333H14.1666C15.55 28.3333 16.6666 29.45 16.6666 30.8333V38.3333H15V30.8333Z"
          fill="black"
        />
        <path
          d="M8.33329 38.3333H15H16.6666V39.1666C16.6666 39.6333 16.3 40 15.8333 40H7.49996C7.03329 40 6.66663 39.6333 6.66663 39.1666V38.3333H8.33329Z"
          fill="black"
        />
        <path
          d="M2.91667 0.333321L21.2333 3.11665C22.45 3.31665 23.3333 4.34999 23.3333 5.58332V15.15L22.6667 15.0167C22.4167 14.9667 22.1667 15.0333 21.9667 15.1833C21.7833 15.35 21.6667 15.5833 21.6667 15.8333V5.58332C21.6667 5.16665 21.3667 4.81665 20.9667 4.74999L2.65 1.98332C2.6 1.96665 2.55 1.96665 2.5 1.96665C2.3 1.96665 2.11667 2.03332 1.96667 2.16665C1.76667 2.33332 1.66667 2.54999 1.66667 2.79999V37.5C1.66667 37.9667 2.05 38.3333 2.5 38.3333H6.66667V39.1667C6.66667 39.6333 7.03333 40 7.5 40H2.5C1.11667 40 0 38.8833 0 37.5V2.79999C0 2.06665 0.316667 1.36665 0.883333 0.899988C1.45 0.416654 2.18333 0.216654 2.91667 0.333321V0.333321Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_150_2266">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinuxPlatformIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 105 123"
      width="16px"
      height="16px"
      {...props}
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="linux" transform="translate(-1.000000, 0.000000)">
          <polygon
            id="Path"
            fill="#FFFFFF"
            points="38.8375 34.7263158 39.175 42.4736842 33.775 52.5789474 23.65 69.1115723 23.65 82.8947368 29.725 102.431579 43.5625 110.178947 64.4875 110.178947 84.0625 95.3578947 92.8375 72.1157895 72.5875 47.5263158 66.85 33.7157895"
          ></polygon>
          <path
            d="M86.7625,53.9263158 C81.3625,46.1789474 76.975,41.4631579 74.6125,31.6947368 C72.25,21.9263158 75.2875,24.6210526 73.2625,16.2 C72.25,11.8210526 70.5625,8.78947368 68.875,6.43157895 C66.85,4.07368421 64.4875,2.72631579 63.1375,2.38947368 C60.1,0.705263158 53.0125,-1.98947368 44.2375,2.72631579 C35.125,7.44210526 36.1375,17.5473684 37.825,38.0947368 C37.825,39.4421053 37.4875,41.1263158 36.8125,42.4736842 C35.4625,45.5052632 33.1,48.2 31.075,50.5578947 C28.7125,53.9263158 26.35,57.2947368 24.6625,61 C20.6125,68.7473684 16.9,78.5157895 17.9125,82.2210526 C19.6,81.8842105 40.8625,114.221053 40.8625,114.894737 C42.2125,114.557895 47.95,114.557895 53.0125,114.557895 C60.1,114.221053 64.15,113.884211 69.8875,115.231579 C69.8875,114.221053 69.55,113.210526 69.55,112.2 C69.55,110.178947 69.8875,108.494737 70.225,106.136842 C70.5625,104.452632 70.9,102.768421 71.2375,100.747368 C67.8625,103.778947 61.7875,107.147368 56.05,108.157895 C50.9875,109.168421 42.55,107.484211 38.5,102.431579 C38.8375,102.431579 39.5125,102.431579 39.85,102.094737 C40.8625,101.757895 41.875,101.421053 42.2125,100.747368 C43.225,99.0631579 42.55,97.3789474 41.875,96.3684211 C41.2,95.3578947 36.1375,91.6526316 33.775,89.6315789 C31.4125,87.6105263 30.0625,86.6 28.7125,85.2526316 C28.7125,85.2526316 26.6875,83.2315789 26.0125,82.5578947 C25.3375,81.8842105 25,81.2105263 24.6625,80.8736842 C23.9875,79.1894737 23.65,77.1684211 23.9875,74.4736842 C24.325,70.7684211 25.675,67.7368421 27.3625,64.3684211 C28.0375,63.0210526 29.725,60.0544434 29.725,60.3263158 C29.725,60.5981882 23.9875,74.4736842 27.025,78.8526316 C27.3625,78.5157895 27.3625,74.4736842 28.7125,70.0947368 C29.725,67.0631579 31.2770996,63.7168406 33.4375,60.3263158 C35.5979004,56.935791 40.525,49.2105263 40.8625,43.8210526 C40.8625,41.4631579 41.2,39.1052632 41.2,37.4210526 C39.85,36.0736842 63.475,32.7052632 64.825,36.4105263 C65.1625,37.7578947 69.8875,49.8842105 72.5875,56.2842105 C73.9375,59.3157895 75.625,62.0105263 76.6375,65.3789474 C77.65,69.0842105 78.325,74.1368421 78.325,79.1894737 C78.325,80.2 78.325,81.8842105 77.9875,83.5684211 C78.6625,83.5684211 90.1375,70.7684211 77.9875,58.3083496 C78.6625,57.9389648 85.5628906,63.189615 85.9003906,71.9475098 C86.2378906,79.021194 83.3875,83.5684211 82.7125,84.5789474 C83.05,84.5789474 89.8,87.6105263 90.1375,87.6105263 C91.4875,87.6105263 94.1875,86.6 94.1875,86.6 C94.525,85.5894737 95.5375,82.8947368 95.5375,81.8842105 C97.9,74.1368421 92.1625,61.6736842 86.7625,53.9263158 Z"
            id="Path"
            fill="#000000"
          ></path>
          <ellipse
            id="Oval"
            fill="#FFFFFF"
            cx="43.9"
            cy="24.9578947"
            rx="4.3875"
            ry="6.73684211"
          ></ellipse>
          <ellipse
            id="Oval"
            fill="#FFFFFF"
            cx="58.5875"
            cy="25.6210527"
            rx="5.2375"
            ry="7.7473685"
          ></ellipse>
          <ellipse
            id="Oval"
            fill="#000000"
            transform="translate(44.007224, 25.714543) rotate(-97.203901) translate(-44.007224, -25.714543) "
            cx="44.0072238"
            cy="25.7145432"
            rx="4.04220429"
            ry="2.36241311"
          ></ellipse>
          <ellipse
            id="Oval"
            fill="#000000"
            cx="58.375"
            cy="26.2194737"
            rx="2.875"
            ry="4.63"
          ></ellipse>
          <path
            d="M103.321827,101.022552 L103.190984,100.96846 C103.21616,100.981023 102.546052,100.651383 102.325375,100.538671 C101.938431,100.341036 101.59158,100.150388 101.244555,99.9401046 C100.347797,99.3967058 99.5274307,98.7658784 98.7510083,97.9832204 C98.1481771,97.3755478 97.5867593,96.6892931 97.0429505,95.8731288 C96.6352804,95.1950032 96.5360572,94.5457695 96.4415314,92.9120444 C96.3745361,91.7541398 96.3366431,91.3086457 96.2319686,90.7077392 C95.9729584,89.2208366 95.4142788,88.1731641 94.3419015,87.4174023 C93.4876547,86.8153688 92.3003464,86.9952972 88.4653594,88.140504 C87.3247999,88.4810988 86.5975092,88.6825133 85.8285783,88.8577712 C82.0748691,89.7133316 79.3230993,89.3034981 77.2810834,86.9709542 C76.272092,85.9639296 75.645274,85.5789474 74.6125,85.5789474 C73.4622114,85.5789474 73.0580134,85.8723365 72.4690777,87.047912 C72.3960414,87.1936998 72.3345166,87.330155 72.2819721,87.4628655 C71.94591,88.3116506 71.9,88.9587486 71.9,92.3263158 C71.9,93.6968283 71.8978784,94.3257258 71.8874108,95.1092646 C71.8572789,97.3647515 71.7609502,99.0952882 71.5556241,100.527593 C71.4007107,101.84179 71.2212023,103.099738 71.0012321,104.459675 C70.8812472,105.201466 70.3377651,108.342495 70.2193167,109.112004 C69.9850905,110.633671 69.875,111.777339 69.875,112.873684 C69.875,116.058557 70.6666922,118.270974 71.8367507,119.146807 L71.9439166,119.239572 C72.8643164,120.158178 74.4905761,120.631579 77.65,120.631579 C80.8209178,120.631579 82.9676284,119.62727 85.3810834,117.218519 C85.5431111,117.056808 85.7029679,116.903144 85.8634547,116.754835 C86.1781303,116.464037 86.4978047,116.191393 86.8475315,115.914564 C87.6398878,115.287369 92.0460438,112.257934 93.31387,111.355865 C94.1669934,110.814026 95.1572493,110.215962 96.4023084,109.485002 C96.6090559,109.363623 96.8238967,109.237946 97.0519418,109.104942 C103.227202,105.503309 103.144435,105.552952 103.606083,105.092204 C103.731452,104.96708 103.852524,104.861152 104.036231,104.709889 C104.132858,104.630649 104.181235,104.590961 104.22149,104.557481 C104.81463,104.064161 105,103.724979 105,102.768421 C105,101.895749 104.452008,101.398545 103.321827,101.022552 Z"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            fill="#FFC107"
          ></path>
          <path
            d="M74.6125,86.5789474 C73.8728602,86.5789474 73.7937054,86.6364023 73.3631553,87.4958239 C73.3027761,87.616347 73.2531863,87.7263317 73.211747,87.8309941 C72.9424605,88.5111255 72.9,89.1096024 72.9,92.3263158 C72.9,93.701259 72.8978682,94.3331649 72.8873216,95.1226228 C72.856663,97.41753 72.758264,99.1852601 72.5487482,100.644659 C72.3920294,101.974172 72.210532,103.246059 71.9884018,104.61935 C71.8669754,105.370053 71.3243919,108.505888 71.2076763,109.26414 C70.9805454,110.739712 70.875,111.836163 70.875,112.873684 C70.875,115.773955 71.5611284,117.69137 72.4360013,118.346246 C72.5117437,118.402942 72.5833675,118.464941 72.6503332,118.531776 C73.3495888,119.229668 74.7302594,119.631579 77.65,119.631579 C80.5380857,119.631579 82.4385656,118.742466 84.6746668,116.510723 C84.8456618,116.340062 85.0147522,116.177522 85.1847607,116.020414 C85.5185559,115.711947 85.8575845,115.422796 86.2268812,115.130477 C87.0502909,114.478701 91.4916745,111.425045 92.6890256,110.571461 L92.7777401,110.511729 C93.6424407,109.962538 94.6417727,109.358993 95.8960231,108.622636 C96.1036384,108.500748 96.3192974,108.374592 96.5481336,108.241127 C102.369125,104.846116 102.539365,104.744007 102.899667,104.384407 C103.052953,104.23142 103.194141,104.107893 103.400587,103.937907 C103.4997,103.85662 103.54484,103.819588 103.582043,103.788645 C103.961486,103.473059 104,103.402589 104,102.768421 C104,102.431688 103.77441,102.227006 103.006154,101.97142 C102.916479,101.941587 102.829031,101.905435 102.744468,101.863236 C102.775583,101.878763 102.099171,101.546022 101.870514,101.429233 C101.46344,101.221317 101.095961,101.01933 100.726316,100.795341 C99.7627165,100.211439 98.8779686,99.5311042 98.0410791,98.6874935 C97.393146,98.0343567 96.7909749,97.2982868 96.185901,96.3883629 C95.6586291,95.5112894 95.5485901,94.7912868 95.443201,92.9698069 C95.3784822,91.8512476 95.3425827,91.4291891 95.2468037,90.8793494 C95.0296516,89.6327419 94.5962877,88.8200697 93.7658342,88.2348046 C93.2967861,87.9042412 92.1894363,88.0720524 88.7514947,89.0986933 C87.5912793,89.4451577 86.846649,89.6513742 86.0508032,89.8327666 C82.0042646,90.7550699 78.9065618,90.3039124 76.5314897,87.6358088 C75.7229038,86.8345457 75.2949088,86.5789474 74.6125,86.5789474 Z M103.6375,100.073684 C104.65,100.410526 106,101.084211 106,102.768421 C106,104.789474 104.9875,105.126316 104.3125,105.8 C103.3,106.810526 97.5625,109.842105 93.85,112.2 C89.125,115.568421 87.775,116.242105 86.0875,117.926316 C83.725,120.284211 81.3625,121.631579 77.65,121.631579 C73.9375,121.631579 72.25,120.957895 71.2375,119.947368 C69.8875,118.936842 68.875,116.578947 68.875,112.873684 C68.875,109.505263 69.8875,106.136842 70.5625,100.410526 C70.9,98.0526316 70.9,95.0210526 70.9,92.3263158 C70.9,88.9578947 70.9,87.9473684 71.575,86.6 C72.25,85.2526316 72.925,84.5789474 74.6125,84.5789474 C76.3,84.5789474 77.3125,85.5894737 77.9875,86.2631579 C82.7125,91.6526316 91.4785156,84.1760329 94.9179688,86.6 C98.3574219,89.0239671 96.8875,93.6736842 97.9,95.3578947 C99.925,98.3894737 102.2875,99.4 103.6375,100.073684 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M34.9404704,101.595794 C34.0519609,100.176672 33.3309916,98.9941544 32.5869936,97.746175 C32.5661586,97.7112264 31.3626628,95.6799149 31.056948,95.1758054 C30.9783118,95.046138 30.9020136,94.9212012 30.8268542,94.7990778 C30.2405446,93.8464075 29.6672483,92.9749609 28.8679505,91.8310235 C25.8604707,86.828328 22.2860366,82.5473684 20.6125,82.5473684 C19.2333497,82.5473684 18.6141297,82.9336265 17.025,84.5052632 L16.9314166,84.6130595 C16.6498803,84.8940469 16.3401018,85.291406 15.8987065,85.9247352 C15.8123789,86.048601 15.722465,86.179167 15.6016686,86.3557135 C15.4480252,86.5805503 15.360259,86.708983 15.2889231,86.8129895 C15.0232076,87.2003978 14.8194935,87.4911683 14.60977,87.7791728 C13.6546497,89.0907991 12.7751227,90.0468879 11.801947,90.7372562 C10.8986839,91.4885082 9.94442289,91.690288 7.55958778,91.9074583 C7.18619225,91.9414608 7.08944447,91.9504084 6.9159699,91.9674225 C4.47771507,92.2065638 3.40958941,92.6325525 2.97822642,93.7088578 C2.6405334,94.5514447 2.59504654,95.2664662 2.77790962,96.121966 C2.84199507,96.421781 2.93391993,96.7428908 3.06923373,97.1512061 C3.14661876,97.3847188 3.44581027,98.2421512 3.48245776,98.3495934 C4.10596441,100.177574 4.4,101.595976 4.4,103.442105 C4.4,104.63152 4.02264282,105.543223 3.2031816,106.837266 C2.49422007,107.956814 2.42654253,108.075465 2.35550695,108.354379 C1.90482815,110.603381 1.94998642,110.332959 1.99587725,110.836774 C2.02188159,111.122264 2.09794963,111.396187 2.24223795,111.697327 C3.41111644,113.404507 5.30155175,114.056528 16.1040274,116.276355 C18.2706843,116.756896 20.3801802,117.45869 23.2704272,118.584393 C30.0186951,121.21273 29.8754094,121.161692 31.5028607,121.309354 C37.2152833,121.827653 40.5375,119.932944 40.539455,113.148027 C40.6783032,110.930786 40.2447243,109.456286 39.0964178,107.693104 C39.231222,107.900091 36.013902,103.490971 34.9404704,101.595794 Z"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            fill="#FFC107"
          ></path>
          <path
            d="M31.7280498,98.2582448 C31.7047467,98.2191563 30.5044703,96.1932785 30.201896,95.6943477 C30.1243634,95.5665001 30.0491997,95.4434209 29.9752162,95.3232083 C29.3994195,94.3876199 28.8371085,93.5328717 28.0875886,92.4642161 L28.010901,92.3462576 C26.7827447,90.3033205 25.2844221,88.1243064 23.886662,86.4502639 C22.3401729,84.5980945 21.0157099,83.5473684 20.6125,83.5473684 C19.5754493,83.5473684 19.1470094,83.8146214 17.825,85.1052632 L17.6378332,85.3208558 C17.4090054,85.5492374 17.1289337,85.908491 16.7191143,86.496514 C16.6347337,86.6175862 16.5462862,86.7460228 16.4269728,86.9204019 C16.2738744,87.144442 16.1854988,87.2737664 16.1135883,87.3786106 C15.8430098,87.7731092 15.6344141,88.0708475 15.4181511,88.3678322 C14.4225609,89.7350342 13.4913285,90.7522023 12.3815644,91.5552374 C11.2765744,92.4514686 10.2205923,92.6692769 7.65027556,92.9033377 C7.27951072,92.9371007 7.18380581,92.9459517 7.01358042,92.9626472 C4.92528107,93.1674653 4.14834496,93.4773221 3.90645284,94.0808736 C3.64568944,94.7315113 3.61302886,95.2449126 3.75581923,95.9129378 C3.81114804,96.171786 3.89367592,96.4600705 4.01846747,96.8366345 C4.09288509,97.0611929 4.38999892,97.912671 4.42891552,98.0267657 C5.08489585,99.9499517 5.4,101.469986 5.4,103.442105 C5.4,104.869861 4.96091433,105.930701 4.04802987,107.372272 C3.42500973,108.356106 3.35748757,108.474486 3.3360139,108.550864 C2.92215629,110.616118 2.95953166,110.392303 2.9917545,110.746063 C3.00504834,110.89201 3.04062003,111.032403 3.11243963,111.196387 C4.08151054,112.543117 5.97933109,113.174911 16.3205549,115.300079 C18.5478686,115.794072 20.6994318,116.509862 23.6333545,117.652576 C30.1982681,120.209499 30.1130552,120.179147 31.5932214,120.313445 C36.7941694,120.785337 39.5375,119.220775 39.5375,113.210526 L39.54141,113.085527 C39.6661365,111.093794 39.2943361,109.829388 38.2584606,108.23884 C38.4212394,108.488781 35.2003363,104.074862 34.0814727,102.108224 C33.1941543,100.690739 32.472429,99.5068635 31.7280498,98.2582448 Z M35.8,101.084211 C38.8375,106.473684 41.875,107.821053 41.5375,113.210526 C41.5375,122.305263 35.125,122.642105 31.4125,122.305263 C27.7,121.968421 21.9625,118.6 15.8875,117.252632 C4.4125,114.894737 2.725,114.221053 1.375,112.2 C0.7,110.852632 1.0375,109.842105 1.375,108.157895 C1.7125,106.810526 3.4,105.463158 3.4,103.442105 C3.4,98.3894737 0.7,96.7052632 2.05,93.3368421 C3.4,89.9684211 9.1375,91.6526316 11.1625,89.9684211 C13.525,88.2842105 14.875,85.2526316 16.225,83.9052632 C17.575,82.5578947 18.5875,81.5473684 20.6125,81.5473684 C23.3125,81.5473684 27.7,87.9473684 29.725,91.3157895 C32.0875,94.6842105 32.425,95.6947368 35.8,101.084211 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M46.8973038,42.8643331 C48.096454,43.1531273 49.9783831,43.2781328 51.2329365,43.1621416 C51.5051291,43.1369757 51.7863487,43.0911622 52.0772525,43.0250656 C53.3386354,42.7384654 54.6318548,42.137374 56.4955389,41.0581679 C56.3436884,41.1461002 58.2595088,40.0205543 58.7462512,39.7519378 C59.5440397,39.3116658 60.1720809,39.0193821 60.7444719,38.8449537 C63.607917,37.4122345 63.8508165,37.0673226 64.1564973,34.0617766 C63.964123,32.5628547 63.3049636,32.1512908 60.810058,31.6507544 C60.6852324,31.6257115 60.1709898,31.524101 60.0391876,31.4976909 C59.7232633,31.4343869 59.4639256,31.3803016 59.2084726,31.323645 L59.0542337,31.2760946 C58.7740248,31.1642296 56.5736569,30.1738222 55.7738556,29.8455939 C54.2874632,29.2355974 52.9606143,28.7983832 51.7199522,28.5463898 C50.9718252,28.3944362 50.2761664,28.3157895 49.6375,28.3157895 C48.2181057,28.3157895 46.6292165,28.8985202 45.0153758,29.8933612 C43.9623869,30.5424688 42.9897112,31.3213502 42.514447,31.7898878 C42.4465409,31.8463659 40.7226475,33.2210544 40.3837484,33.5416763 C39.7344386,34.1559681 39.5,34.6284309 39.5,35.4 C39.5,36.932941 40.2014913,37.8020209 42.7119853,39.2494671 L42.8421297,39.3388941 C43.2251295,39.6492938 44.4883893,41.1437224 44.6897949,41.3507189 C45.3694238,42.0492138 46.0596609,42.5421621 46.8973038,42.8643331 Z"
            id="Path"
            stroke="#000000"
            strokeWidth="2"
            fill="#FFC107"
          ></path>
          <path
            d="M51.1408729,42.1663885 C51.3682034,42.1453704 51.606325,42.106578 51.8556885,42.0499198 C52.9930939,41.7914886 54.2119965,41.2249398 55.9944223,40.1927881 C55.8310981,40.2873645 57.762488,39.1526715 58.2630789,38.8764126 C59.0808131,38.4251331 59.7423809,38.1141977 60.3701574,37.91417 C62.8122579,36.6942565 62.8951059,36.5978471 63.1495243,34.0814592 C63.0159003,33.2246305 62.6405354,33.0379173 60.6133542,32.6312174 C60.4903972,32.6065493 59.9763095,32.5049695 59.8427159,32.4782004 C59.520637,32.4136631 59.2549993,32.358264 58.9919451,32.2999215 C58.8867247,32.2765848 58.7835629,32.244781 58.6834674,32.2048208 C58.3778819,32.0828249 56.1716326,31.0897703 55.3941957,30.77072 C53.9612688,30.1826651 52.6905672,29.7639522 51.5209045,29.5263796 C50.8347967,29.3870228 50.2047117,29.3157895 49.6375,29.3157895 C48.4350331,29.3157895 47.0103939,29.838281 45.5401266,30.7446171 C44.5550864,31.3518383 43.6428415,32.0823289 43.2878332,32.4366452 L43.1538941,32.5587229 C43.0545465,32.6413512 41.373754,33.9816696 41.0709954,34.2681001 C40.6091684,34.7050202 40.5,34.9250268 40.5,35.4 C40.5,36.5030095 40.9783222,37.0956045 43.2114707,38.3831448 C43.3028124,38.4358086 43.3898466,38.495613 43.4717595,38.5619987 C43.9418835,38.9430077 45.2628621,40.5057174 45.4065145,40.6533575 C45.9750589,41.2376842 46.5330246,41.641499 47.1962221,41.9073922 C48.2893123,42.1590395 50.0155533,42.2704312 51.1408729,42.1663885 Z M42.2125,40.1157895 C39.5125,38.559082 38.5,37.4210526 38.5,35.4 C38.5,33.3789474 39.85,32.7052632 41.875,31.0210526 C42.2125,30.6842105 45.925,27.3157895 49.6375,27.3157895 C53.35,27.3157895 57.7375,29.6736842 59.425,30.3473684 C62.4625,31.0210526 64.825,31.0210526 65.1625,34.0526316 C64.825,37.4210526 64.4875,38.0947368 61.1125,39.7789474 C58.75,40.4526316 54.9682617,43.8210526 51.325,44.1578947 C49.9892083,44.281397 47.95,44.1578947 46.6,43.8210526 C44.15979,42.9099121 43.1486816,40.8745117 42.2125,40.1157895 Z"
            id="Path"
            fill="#000000"
            fillRule="nonzero"
          ></path>
          <path
            d="M79.2019043,91.3461914 C79.4038086,92.2351074 81.3625,93 82.7125,93 C84.7375,93 86.7625,91.6526316 87.775,90.3052632 C88.6644287,89.4179688 89.4625,87.6105263 89.8,87.2736842 C89.8,87.2736842 89.4625,86.9368421 89.4625,86.6 C89.125,85.9263158 88.1125,85.2526316 86.7625,84.9157895 C85.75,84.5789474 84.0625,84.2421053 83.3875,84.2421053 C80.35,83.9052632 78.6625,84.9157895 77.65,85.9263158 C77.65,85.9263158 79,87.6105263 79,88.6210526 C79,89.2947368 79,90.4572754 79.2019043,91.3461914 Z"
            id="Path"
            fill="#000000"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export const WindowsPlatformIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 106 108"
      width="16px"
      height="16px"
      {...props}
    >
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="windows" fill="#0078D6">
          <polygon
            id="svg_23"
            points="46.9076581 51.2607252 105.78942 51.2607252 105.78942 0 46.9076581 8.59204697"
          ></polygon>
          <polygon
            id="svg_24"
            points="42.7574129 51.2607252 42.7574129 9.19544243 0 15.4322189 0 51.2607252"
          ></polygon>
          <polygon
            id="svg_25"
            points="42.7574129 55.4084351 0 55.4084351 0 91.6932909 42.7574129 98.0010551"
          ></polygon>
          <polygon
            id="svg_26"
            points="46.9076581 55.4084351 46.9076581 98.6145917 105.78942 107.300444 105.78942 55.4084351"
          ></polygon>
        </g>
      </g>
    </svg>
  );
};

export const OpenShiftPlatformIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="-1.7338671 -1.7338671 61.2633042 65.4082292"
      width="16px"
      height="16px"
      {...props}
    >
      <defs id="defs45455" />
      <path
        d="m 54.22782,11.986615 c -0.5725,-1.1825 -1.235,-2.3237504 -2.00375,-3.4000004 l -8.2125,2.9887504 c 0.955,0.9775 1.7575,2.07625 2.41375,3.25125 l 7.8025,-2.84 z m -36.30287,9.08338 -8.215,2.98875 c 0.105,1.3175 0.3325,2.61875 0.65125,3.89375 l 7.80375,-2.84125 c -0.25375,-1.32 -0.34375,-2.68 -0.24,-4.04125"
        id="path44560"
        fill="#c22133"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
      />
      <path
        d="m 36.1562,9.6601146 c 1.70875,0.7975004 3.18875,1.8850004 4.4375,3.1600004 l 8.2125,-2.9887504 c -2.275,-3.1925 -5.37375,-5.86 -9.17,-7.63125 -11.74125,-5.475 -25.74875,-0.3775 -31.2225,11.3625004 -1.7725,3.79875 -2.43125,7.83375 -2.12125,11.74125 l 8.21375,-2.98875 c 0.13625,-1.78 0.57,-3.56375 1.36625,-5.27375 C 19.42995,9.4138646 28.5287,6.1038646 36.1562,9.6601146"
        id="path44564"
        fill="#db212e"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
      />
      <path
        d="m 44.91582,24.668245 c -0.13125,1.77875 -0.58,3.5625 -1.37875,5.27375 -3.55625,7.62875 -12.65625,10.93875 -20.2825,7.3825 -1.71125,-0.79875 -3.2025,-1.8775 -4.44625,-3.155 l -8.19625,2.9825 c 2.27,3.1925 5.365,5.86125 9.16375,7.63375 11.74125,5.47375 25.74625,0.37625 31.22125,-11.365 1.77375,-3.79625 2.4275,-7.83125 2.115,-11.735 l -8.19625,2.9825 z"
        id="path44572"
        fill="#db212e"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
      />
      <path
        d="m 46.93545,14.641115 -7.80375,2.84 c 1.45,2.5975 2.135,5.5875 1.91,8.595 l 8.19625,-2.98125 c -0.235,-2.94125 -1.01875,-5.8125 -2.3025,-8.45375 m -36.06275,13.124 -7.80375,2.8425 c 0.71625,2.845 1.96,5.54875 3.67,7.955 l 8.195,-2.98375 c -2.10375,-2.16 -3.5025,-4.89375 -4.06125,-7.81375"
        id="path44576"
        fill="#eb2126"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
      />
      <path
        d="m 53.03832,9.8229946 c -0.25875,-0.42 -0.5275,-0.83375 -0.81375,-1.23625 l -8.2125,2.9887504 c 0.36125,0.37 0.69375,0.7625 1.01125,1.165 l 8.015,-2.9175004 z M 17.89357,22.719365 c -0.02,-0.5475 -0.0113,-1.0975 0.0312,-1.64875 l -8.215,2.98875 c 0.0425,0.52625 0.10875,1.04875 0.1875,1.57 l 7.99625,-2.91 z"
        id="path44584"
        fill="#ad213b"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
      />
      <path
        d="m 53.11157,21.685615 -8.19625,2.9825 c -0.0863,1.18 -0.31625,2.3625 -0.6925,3.525 l 8.92125,-3.2525 c 0.0638,-1.09 0.0537,-2.1775 -0.0325,-3.255 m -42.49875,15.4675 c 0.63125,0.88875 1.33,1.73625 2.08875,2.53625 l 8.9225,-3.25375 c -1.0425,-0.6525 -1.985,-1.41375 -2.81625,-2.26625 l -8.195,2.98375 z"
        id="path44588"
        fill="#ba2133"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
      />
      <path
        d="m 52.68932,54.532115 0,0.74 2.14625,0 0,6.55375 0.8125,0 0,-6.55375 2.1475,0 0,-0.74 -5.10625,0 z m -4.9285,0.73938 0,2.4175 2,0 0,0.74 -2,0 0,3.39625 -0.8125,0 0,-7.2925 4.2825,0 0,0.73875 -3.47,0 z m -3.71775,-0.7385 0.8125,0 0,7.29375 -0.8125,0 0,-7.29375 z m -2.90425,7.29287 0,-3.43875 -3.62625,0 0,3.43875 -0.8125,0 0,-7.29375 0.8125,0 0,3.11625 3.62625,0 0,-3.11625 0.8125,0 0,7.29375 -0.8125,0 z m -8.66675,0.11463 c -0.99,0 -1.87625,-0.4275 -2.44875,-1.01 l 0.5425,-0.605 c 0.55125,0.53125 1.1875,0.87625 1.9375,0.87625 0.96875,0 1.57375,-0.48 1.57375,-1.25125 0,-0.6775 -0.40625,-1.0625 -1.74,-1.5425 -1.57375,-0.5625 -2.105,-1.0725 -2.105,-2.125 0,-1.1675 0.91625,-1.86625 2.28125,-1.86625 0.98,0 1.605,0.2925 2.22,0.7825 l -0.52125,0.635 c -0.53125,-0.4375 -1.02125,-0.6775 -1.75,-0.6775 -1.00125,0 -1.4175,0.5 -1.4175,1.07375 0,0.605 0.27125,0.9475 1.73,1.47 1.615,0.5825 2.115,1.125 2.115,2.20875 0,1.14625 -0.89625,2.03125 -2.4175,2.03125 m -5.7415,-0.11463 -2.6775,-3.98 c -0.1775,-0.27125 -0.4175,-0.63625 -0.51125,-0.82375 0,0.27125 0.0212,1.1875 0.0212,1.59375 l 0,3.21 -1.43875,0 0,-7.29375 1.39625,0 2.585,3.855 c 0.1775,0.27125 0.41625,0.63625 0.51,0.82375 0,-0.27125 -0.02,-1.1875 -0.02,-1.595 l 0,-3.08375 1.4375,0 0,7.29375 -1.3025,0 z m -11.50112,0 0,-7.29375 5.06375,0 0,1.4275 -3.605,0 0,1.26125 2.095,0 0,1.41625 -2.095,0 0,1.76125 3.76125,0 0,1.4275 -5.22,0 z m -4.14475,-2.58362 -1.605,0 0,2.58375 -1.45875,0 0,-7.29375 3.18875,0 c 1.375,0 2.51125,0.76125 2.51125,2.3125 0,1.68875 -1.125,2.3975 -2.63625,2.3975 m 0.0738,-3.2925 -1.67875,0 0,1.875 1.69875,0 c 0.6775,0 1.0425,-0.31375 1.0425,-0.94875 0,-0.635 -0.4175,-0.92625 -1.0625,-0.92625 M 3.21,61.940495 c -1.9075,0 -3.21,-1.39625 -3.21,-3.75125 0,-2.355 1.32375,-3.7725 3.23125,-3.7725 1.89625,0 3.19875,1.3975 3.19875,3.7525 0,2.355 -1.32375,3.77125 -3.22,3.77125 m -0.01,-6.075 c -1.02125,0 -1.69875,0.82375 -1.69875,2.30375 0,1.48 0.70875,2.3225 1.73,2.3225 1.02125,0 1.6975,-0.8225 1.6975,-2.3025 0,-1.48 -0.7075,-2.32375 -1.72875,-2.32375"
        id="path44622"
        fill="#241f21"
        fillOpacity={1}
        fillRule="nonzero"
        stroke="none"
      />
    </svg>
  );
};

export const K8sPlatformIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 122.88 118.78"
      height={"16px"}
      width={"16px"}
      {...props}
    >
      <g>
        <path
          fill="#326DE6"
          d="M112.13,26.42c-0.7-2.25-2.39-4.08-4.5-5.2L64.78,0.7C63.65,0.14,62.39,0,61.26,0s-2.39,0-3.51,0.28 L14.89,20.94c-2.11,0.98-3.65,2.81-4.22,5.2L0.14,72.37c-0.42,2.39,0.14,4.78,1.55,6.75l29.65,36.67c1.69,1.69,4.08,2.81,6.46,2.95 h47.21c2.53,0.28,4.92-0.84,6.46-2.95l29.65-36.67c1.41-1.97,1.97-4.36,1.69-6.75L112.13,26.42L112.13,26.42L112.13,26.42z"
        />
        <path
          fill="#FFFFFF"
          d="M105.59,69.45L105.59,69.45c-0.14,0-0.28,0-0.28-0.14c0-0.14-0.28-0.14-0.56-0.14 c-0.56-0.14-1.12-0.14-1.69-0.14c-0.28,0-0.56,0-0.84-0.14l-0.14,0c-1.55-0.14-3.23-0.42-4.78-0.84c-0.42-0.14-0.84-0.56-0.98-0.98 c0.14,0,0,0,0,0l0,0l-1.12-0.28c0.56-4.08,0.28-8.29-0.56-12.37c-0.98-4.08-2.67-8.01-4.92-11.52l0.84-0.84l0,0v-0.14 c0-0.42,0.14-0.98,0.42-1.26c1.26-1.12,2.53-1.97,3.93-2.81l0,0c0.28-0.14,0.56-0.28,0.84-0.42c0.56-0.28,0.98-0.56,1.55-0.84 c0.14-0.14,0.28-0.14,0.42-0.28s0-0.14,0-0.28l0,0c1.26-0.98,1.55-2.67,0.56-3.93c-0.42-0.56-1.26-0.98-1.97-0.98 c-0.7,0-1.41,0.28-1.97,0.7l0,0l-0.14,0.14c-0.14,0.14-0.28,0.28-0.42,0.28c-0.42,0.42-0.84,0.84-1.12,1.26 c-0.14,0.28-0.42,0.42-0.56,0.56l0,0c-0.98,1.12-2.25,2.25-3.51,3.09c-0.28,0.14-0.56,0.28-0.84,0.28c-0.14,0-0.42,0-0.56-0.14 l-0.14,0l-1.12,0.7c-1.12-1.12-2.39-2.25-3.51-3.37c-5.2-4.08-11.66-6.6-18.27-7.31l-0.14-1.12l0,0v0.14 c-0.42-0.28-0.56-0.7-0.7-1.12c0-1.55,0-3.09,0.28-4.78v-0.14c0-0.28,0.14-0.56,0.14-0.84c0.14-0.56,0.14-1.12,0.28-1.69V16.9l0,0 c0.14-1.41-0.98-2.81-2.39-2.95c-0.84-0.14-1.69,0.28-2.39,0.98c-0.56,0.56-0.84,1.26-0.84,1.97l0,0v0.7 c0,0.56,0.14,1.12,0.28,1.69c0.14,0.28,0.14,0.56,0.14,0.84v0.14c0.28,1.55,0.28,3.09,0.28,4.78c-0.14,0.42-0.28,0.84-0.7,1.12 v0.28l0,0l-0.14,1.12c-1.55,0.14-3.09,0.42-4.78,0.7c-6.6,1.41-12.65,4.92-17.28,9.84l-0.84-0.56l-0.14,0 c-0.14,0-0.28,0.14-0.56,0.14c-0.28,0-0.56-0.14-0.84-0.28c-1.26-0.98-2.53-2.11-3.51-3.23l0,0c-0.14-0.28-0.42-0.42-0.56-0.56 c-0.42-0.42-0.7-0.84-1.12-1.26c-0.14-0.14-0.28-0.14-0.42-0.28c-0.14-0.14-0.14-0.14-0.14-0.14l0,0c-0.56-0.42-1.26-0.7-1.97-0.7 c-0.84,0-1.55,0.28-1.97,0.98c-0.84,1.26-0.56,2.95,0.56,3.93l0,0c0.14,0,0.14,0.14,0.14,0.14s0.28,0.28,0.42,0.28 c0.42,0.28,0.98,0.56,1.55,0.84c0.28,0.14,0.56,0.28,0.84,0.42l0,0c1.41,0.84,2.81,1.69,3.93,2.81c0.28,0.28,0.56,0.84,0.42,1.26 v-0.14l0,0l0.84,0.84c-0.14,0.28-0.28,0.42-0.42,0.7c-4.36,6.89-6.18,15.04-4.92,23.05l-1.12,0.28l0,0c0,0.14-0.14,0.14-0.14,0.14 c-0.14,0.42-0.56,0.7-0.98,0.98c-1.55,0.42-3.09,0.7-4.78,0.84l0,0c-0.28,0-0.56,0-0.84,0.14c-0.56,0-1.12,0.14-1.69,0.14 c-0.14,0-0.28,0.14-0.56,0.14c-0.14,0-0.14,0-0.28,0.14l0,0c-1.55,0.28-2.53,1.69-2.25,3.23l0,0c0.28,1.26,1.55,2.11,2.81,1.97 c0.28,0,0.42,0,0.7-0.14l0,0c0.14,0,0.14,0,0.14-0.14c0-0.14,0.42,0,0.56,0c0.56-0.14,1.12-0.42,1.55-0.56 c0.28-0.14,0.56-0.28,0.84-0.28h0.14c1.55-0.56,2.95-0.98,4.64-1.26h0.14c0.42,0,0.84,0.14,1.12,0.42c0.14,0,0.14,0.14,0.14,0.14 l0,0l1.26-0.14c2.11,6.46,6.04,12.23,11.52,16.44c1.26,0.98,2.39,1.83,3.79,2.53l-0.7,0.98l0,0c0,0.14,0.14,0.14,0.14,0.14 c0.28,0.42,0.28,0.98,0.14,1.41c-0.56,1.41-1.41,2.81-2.25,4.08v0.14c-0.14,0.28-0.28,0.42-0.56,0.7 c-0.28,0.28-0.56,0.84-0.98,1.41c-0.14,0.14-0.14,0.28-0.28,0.42c0,0,0,0.14-0.14,0.14l0,0c-0.7,1.41-0.14,3.09,1.12,3.79 c0.28,0.14,0.7,0.28,0.98,0.28c1.12,0,2.11-0.7,2.67-1.69l0,0c0,0,0-0.14,0.14-0.14c0-0.14,0.14-0.28,0.28-0.42 c0.14-0.56,0.42-0.98,0.56-1.55l0.28-0.84l0,0c0.42-1.55,1.12-2.95,1.83-4.36c0.28-0.42,0.7-0.7,1.12-0.84c0.14,0,0.14,0,0.14-0.14 l0,0l0.56-1.12c3.93,1.55,8.01,2.25,12.22,2.25c2.53,0,5.06-0.28,7.59-0.98c1.55-0.28,3.09-0.84,4.5-1.26l0.56,0.98l0,0 c0.14,0,0.14,0,0.14,0.14c0.42,0.14,0.84,0.42,1.12,0.84c0.7,1.41,1.41,2.81,1.83,4.36v0.14l0.28,0.84 c0.14,0.56,0.28,1.12,0.56,1.55c0.14,0.14,0.14,0.28,0.28,0.42c0,0,0,0.14,0.14,0.14l0,0c0.56,0.98,1.55,1.69,2.67,1.69 c0.42,0,0.7-0.14,1.12-0.28c0.56-0.28,1.12-0.84,1.26-1.55c0.14-0.7,0.14-1.41-0.14-2.11l0,0c0-0.14-0.14-0.14-0.14-0.14 c0-0.14-0.14-0.28-0.28-0.42c-0.28-0.56-0.56-0.98-0.98-1.41c-0.14-0.28-0.28-0.42-0.56-0.7v-0.28c-0.98-1.26-1.69-2.67-2.25-4.08 c-0.14-0.42-0.14-0.98,0.14-1.41c0-0.14,0.14-0.14,0.14-0.14l0,0l-0.42-1.12c7.17-4.36,12.65-11.1,15.18-19.11l1.12,0.14l0,0 c0.14,0,0.14-0.14,0.14-0.14c0.28-0.28,0.7-0.42,1.12-0.42l0.14,0c1.55,0.28,3.09,0.7,4.5,1.26h0.14c0.28,0.14,0.56,0.28,0.84,0.28 c0.56,0.28,0.98,0.56,1.55,0.7c0.14,0,0.28,0.14,0.56,0.14c0.14,0,0.14,0,0.28,0.14l0,0c0.28,0.14,0.42,0.14,0.7,0.14 c1.26,0,2.39-0.84,2.81-1.97C107.98,70.86,106.85,69.73,105.59,69.45L105.59,69.45L105.59,69.45z M64.98,65.09l-3.79,1.83 l-3.79-1.83l-0.98-4.08l2.67-3.37h4.22l2.67,3.37L64.98,65.09L64.98,65.09z M87.88,55.96c0.7,2.95,0.84,5.9,0.56,8.85l-13.35-3.79 l0,0c-1.26-0.28-1.97-1.55-1.69-2.81c0.14-0.42,0.28-0.7,0.56-0.98l10.54-9.56C86.05,50.2,87.18,53.01,87.88,55.96L87.88,55.96 L87.88,55.96z M80.29,42.47l-11.52,8.15c-0.98,0.56-2.39,0.42-3.09-0.56c-0.28-0.28-0.42-0.56-0.42-0.98l-0.84-14.19 C70.6,35.59,76.08,38.26,80.29,42.47L80.29,42.47L80.29,42.47L80.29,42.47z M54.86,35.3l2.81-0.56l-0.7,14.05l0,0 c0,1.26-1.12,2.25-2.39,2.25c-0.42,0-0.7-0.14-1.12-0.28l-11.66-8.29C45.44,38.96,49.94,36.43,54.86,35.3L54.86,35.3z M37.72,47.67 l10.4,9.27l0,0c0.98,0.84,1.12,2.25,0.28,3.23c-0.28,0.42-0.56,0.56-1.12,0.7l-13.63,3.93C33.22,58.91,34.62,52.87,37.72,47.67 L37.72,47.67z M35.33,71.42l13.91-2.39c1.12,0,2.25,0.7,2.39,1.83c0.14,0.42,0.14,0.98-0.14,1.41l0,0l-5.34,12.93 C41.23,81.96,37.29,77.04,35.33,71.42L35.33,71.42z M67.23,88.84c-1.97,0.42-3.93,0.7-6.04,0.7c-2.95,0-6.04-0.56-8.85-1.41 l6.89-12.51c0.7-0.84,1.83-1.12,2.81-0.56c0.42,0.28,0.7,0.56,1.12,0.98l0,0l6.75,12.23C69.05,88.42,68.21,88.56,67.23,88.84 L67.23,88.84L67.23,88.84z M84.37,76.62c-2.11,3.37-5.06,6.32-8.43,8.43l-5.48-13.21c-0.28-1.12,0.28-2.25,1.26-2.67 c0.42-0.14,0.84-0.28,1.26-0.28l14.05,2.39C86.34,73.24,85.49,75.07,84.37,76.62L84.37,76.62z"
        />
      </g>
    </svg>
  );
};

export const MacOSPlatformIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1000 1187.198"
      width="16"
      height="16"
      {...props}
    >
      <path d="m 979.04184,925.18785 c -17.95397,41.47737 -39.20563,79.65705 -63.82824,114.75895 -33.56298,47.8528 -61.04356,80.9761 -82.22194,99.3698 -32.83013,30.192 -68.00529,45.6544 -105.67203,46.5338 -27.04089,0 -59.6512,-7.6946 -97.61105,-23.3035 -38.08442,-15.5358 -73.08371,-23.2303 -105.08578,-23.2303 -33.56296,0 -69.55888,7.6945 -108.06101,23.2303 -38.5608,15.6089 -69.62484,23.7432 -93.37541,24.5493 -36.12049,1.5389 -72.1237,-14.3632 -108.06101,-47.7796 -22.93711,-20.0059 -51.62684,-54.3017 -85.99592,-102.8874 C 92.254176,984.54592 61.937588,924.38175 38.187028,855.7902 12.750995,781.70252 0,709.95986 0,640.50361 0,560.94181 17.191859,492.32094 51.626869,434.81688 78.689754,388.62753 114.69299,352.19192 159.75381,325.44413 c 45.06086,-26.74775 93.74914,-40.37812 146.18212,-41.25019 28.68971,0 66.3125,8.8744 113.06613,26.31542 46.62174,17.49964 76.55727,26.37404 89.68198,26.37404 9.8124,0 43.06758,-10.37669 99.4431,-31.06405 53.31237,-19.18512 98.30724,-27.12887 135.16787,-23.99975 99.8828,8.06098 174.92313,47.43518 224.82789,118.37174 -89.33023,54.12578 -133.51903,129.93556 -132.63966,227.18753 0.8061,75.75115 28.28668,138.78795 82.2952,188.8393 24.47603,23.23022 51.81008,41.18421 82.22186,53.93522 -6.59525,19.12648 -13.557,37.44688 -20.95846,55.03446 z M 749.96366,23.751237 c 0,59.37343 -21.69138,114.810233 -64.92748,166.121963 -52.17652,60.99961 -115.28658,96.24803 -183.72426,90.68597 -0.87204,-7.12298 -1.37769,-14.61967 -1.37769,-22.49743 0,-56.99843 24.81315,-117.99801 68.87738,-167.873453 21.99909,-25.25281 49.978,-46.25018 83.90738,-63.00018 C 686.57507,10.688027 718.59913,1.5631274 748.71783,5.2734376e-4 749.59727,7.9378274 749.96366,15.875627 749.96366,23.750467 Z" />
    </svg>
  );
};

export const ArrowDropDownIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={"16px"}
      width={"16px"}
      {...props}
    >
      <path d="m7 10 5 5 5-5z"></path>
    </svg>
  );
};

export const ArrowDropUpIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={"16px"}
      width={"16px"}
      {...props}
    >
      <path d="m7 14 5-5 5 5z"></path>
    </svg>
  );
};

export const CPUIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
      <rect x="9" y="9" width="6" height="6"></rect>
      <line x1="9" y1="1" x2="9" y2="4"></line>
      <line x1="15" y1="1" x2="15" y2="4"></line>
      <line x1="9" y1="20" x2="9" y2="23"></line>
      <line x1="15" y1="20" x2="15" y2="23"></line>
      <line x1="20" y1="9" x2="23" y2="9"></line>
      <line x1="20" y1="14" x2="23" y2="14"></line>
      <line x1="1" y1="9" x2="4" y2="9"></line>
      <line x1="1" y1="14" x2="4" y2="14"></line>
    </svg>
  );
};

export const MemoryIcon: React.FC<IconProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <line x1="22" y1="12" x2="2" y2="12"></line>
      <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
      <line x1="6" y1="16" x2="6.01" y2="16"></line>
      <line x1="10" y1="16" x2="10.01" y2="16"></line>
    </svg>
  );
};
